import React from 'react';
import DataTable from 'react-data-table-component';
import { useTranslation } from 'react-i18next';

export const Table = ({ 
  myData,
  myColumns,
  conditionalRowStyles,
 }) => {
  const { t } = useTranslation();
  return (
    <DataTable
      className="my_table"
      noHeader={true}
      responsive={true}
      columns={myColumns}
      data={myData}
      striped={true}
      highlightOnHover={true}
      conditionalRowStyles={conditionalRowStyles}
      noDataComponent={t('paid-leagues.noData')}
    />
  );
};